<template>
  <el-container>
    <el-aside width="200px">
      <Left/>
    </el-aside>
  </el-container>
</template>

<script>
import Left from './Left'

export default {
  data () {
    return {
      
    }
  },

  components:{
    Left
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Home.vue